// extracted by mini-css-extract-plugin
export default {"centerAlign":"CartOnboarding_centerAlign__MStii"};